import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SysLog } from '@app/_models';
import { map, first } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(private http: HttpClient) { }

  getAll(filter?: object) {
    let fstr = filter  ? stringi(filter) : '&';
    return this.http.get<SysLog[]>(`/api/syslogs?${fstr.substring(1)}`).pipe(first());
  }

  getById(id: string) {
    return this.http.get<SysLog>(`/api/syslogs/${id}`).pipe(first());
  }
}

function stringi(ob: any, path = ''): string {
  if (typeof ob === 'object') {
      if (path.length) {
          if (Array.isArray(ob))
            return ob.map(v => stringi(v, `${path}[]`)).join('');
          else
            return Object.keys(ob).map(k => stringi(ob[k], `${path}[${k}]`)).join('');
      }
      else
          return Object.keys(ob).map(k => stringi(ob[k], k)).join('');
  }
  else
      return '&' + path + '=' + ob;
}
